import { render, staticRenderFns } from "./MapMovementsList.vue?vue&type=template&id=30d180c2"
import script from "./MapMovementsList.vue?vue&type=script&lang=js"
export * from "./MapMovementsList.vue?vue&type=script&lang=js"
import style0 from "./MapMovementsList.vue?vue&type=style&index=0&id=30d180c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports